// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookieConsentModal__content {
  height: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #4d4d4d;
}
.cookieConsentModal__title {
  font-size: 30px;
  font-weight: 700;
}
.cookieConsentModal__icon {
  align-self: center;
  font-size: 86px;
}
.cookieConsentModal__link:link {
  color: inherit;
  text-decoration-color: #999999;
}
.cookieConsentModal__link:visited {
  color: inherit;
  text-decoration-color: #999999;
}
.cookieConsentModal__buttonsContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 32px;
}
.cookieConsentModal__button {
  height: 44px;
  --padding-top: 22px;
  --padding-bottom: 22px;
  --padding-start: 4px;
  --padding-end: 8px;
  margin: 0;
  flex-grow: 1;
  --border-radius: 8px;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 400;
}
.cookieConsentModal__button--red {
  --background: var(--background-gradient);
}
.cookieConsentModal__button--red:hover {
  --background: var(--background-gradient-hover);
}
.cookieConsentModal__button--gray {
  --background: #4c4c4c;
}
.cookieConsentModal__button--gray:hover {
  --background: #565656;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/shared/cookie-consent-modal/cookie-consent-modal.component.scss"],"names":[],"mappings":"AAGE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;AAHJ;AAME;EACE,kBAAA;EACA,eAAA;AAJJ;AAOE;EACE,cAAA;EACA,8BAAA;AALJ;AAQE;EACE,cAAA;EACA,8BAAA;AANJ;AASE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAPJ;AAUE;EACE,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AARJ;AAUI;EACE,wCAAA;AARN;AAUM;EACE,8CAAA;AARR;AAYI;EACE,qBAAA;AAVN;AAWM;EACE,qBAAA;AATR","sourcesContent":["@import \"../../../mixins/web-page-component.mixin.scss\";\n\n.cookieConsentModal {\n  &__content {\n    height: 100%;\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: #4d4d4d;\n  }\n\n  &__title {\n    font-size: 30px;\n    font-weight: 700;\n  }\n\n  &__icon {\n    align-self: center;\n    font-size: 86px;\n  }\n\n  &__link:link {\n    color: inherit;\n    text-decoration-color: #999999;\n  }\n\n  &__link:visited {\n    color: inherit;\n    text-decoration-color: #999999;\n  }\n\n  &__buttonsContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 32px;\n  }\n\n  &__button {\n    height: 44px;\n    --padding-top: 22px;\n    --padding-bottom: 22px;\n    --padding-start: 4px;\n    --padding-end: 8px;\n    margin: 0;\n    flex-grow: 1;\n    --border-radius: 8px;\n    text-transform: capitalize;\n    font-size: 14px;\n    font-weight: 400;\n\n    &--red {\n      --background: var(--background-gradient);\n\n      &:hover {\n        --background: var(--background-gradient-hover);\n      }\n    }\n\n    &--gray {\n      --background: #4c4c4c;\n      &:hover {\n        --background: #565656;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
